module.exports = __webpack_public_path__ + "img/blaze_hero_desktop.8efe9439.png";